import type { BatchPreviewPageLayoutProps } from "./batch-preview-page-layout.type";

import { Spin } from "antd";
import classNames from "classnames";

import BaseHeader from "@/components/Header/BaseHeader";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";

import "./batch-preview-page-layout.style.less";

export const BatchPreviewPageLayout = ({
  title,
  loading,
  error,
  children,
}: BatchPreviewPageLayoutProps) => {
  return (
    <div
      className={classNames("batch-preview-page-layout-content", {
        "-with-error": error,
      })}
    >
      <BaseHeader title={title} />
      <AppLayoutPage>
        {error ? error : loading ? <Spin /> : children}
      </AppLayoutPage>
    </div>
  );
};
